"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Zwraca czesc schematu na podstawie sciezki
 * @param path sciezka w formacie pole.tablica[0].pole2
 */
function schemaValue(schema, path) {
    var tpath = path
        .replace(/\[/g, '.')
        .replace(/\]/g, '')
        .split('.');
    return _schemaValue(tpath, 0, schema);
}
exports.default = schemaValue;
function _schemaValue(path, pindex, schema) {
    var prop = path[pindex];
    if (prop === '') {
        if (pindex === path.length - 1) {
            return null;
        }
        else {
            return _schemaValue(path, pindex + 1, schema);
        }
    }
    if (schema.type === 'object' && schema.properties) {
        var schitem = schema.properties[prop];
        if (schitem === undefined) {
            return null;
        }
        if (pindex === path.length - 1) {
            return schitem;
        }
        else {
            return _schemaValue(path, pindex + 1, schitem);
        }
    }
    else if (schema.type === 'array' && schema.items) {
        var schitem = schema.items;
        if (schitem === undefined) {
            return null;
        }
        if (pindex === path.length - 1) {
            return schitem;
        }
        else {
            return _schemaValue(path, pindex + 1, schitem);
        }
    }
    else {
        return null;
    }
}
//# sourceMappingURL=schemaValue.js.map